export default __webpack_public_path__ + "static/media/cv.131f4618.pdf";